import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const getAuthStatus = () => !!localStorage.getItem("jawab_token");

const PrivateRoute = () => {
    const isAuthenticated = getAuthStatus();
    return isAuthenticated ? <Outlet /> : <Navigate to="/user/login" replace />;
};

const PublicRoute = () => {
    const isAuthenticated = getAuthStatus();
    return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />;
};

export { PrivateRoute, PublicRoute };
